export default class MenuItem {

  constructor(name, {
    text,
    path = '',
    weight = 0,
    icon = '',
    image = '',
    linkOptions = {},
    children = [],
    itemType = '',
    permission = '',
    isGroup = false,
    isSystem = false,
    uuid,
  }) {
    if (!name){
      throw new Error('Please provide name in MenuItem constructor');
    }
    this.path = path;
    this.isGroup = isGroup;
    this.isSystem = isSystem;
    this.text = text;
    this.weight = weight;
    this.icon = icon;
    this.image = image;
    this.linkOptions = linkOptions;
    this.children = children;
    this.itemType = itemType;
    this.permission = permission;
    this.name = name;
    this.uuid = uuid;
  }
}
